<div style="display: flex; height: 100%;">
  <div style="display: flex; overflow: hidden; width: 100%;">
    <div style="display: flex; flex-direction: column; margin: 20px; z-index: 1; overflow: hidden; width: 100%;">
      <mat-toolbar color="primary" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; padding: 20px;" class="toolbar-over-card">
        <!-- Title -->
        <div>Audit Document Access | Total Entries: <span>{{totalEntries$ | async }}</span></div>

        <div style="display: flex; font-size: medium;">
          <!-- Prev, Next, Expand -->
          <button mat-icon-button [disabled]="(hasPreviousPage$ | async) === false" (click)="loadPreviousPage()"
                  matTooltip="Previous page">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button mat-icon-button [disabled]="(hasNextPage$ | async) === false" (click)="loadNextPage()" matTooltip="Next page">
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="export()">
              <mat-icon>upload</mat-icon>
              <span>Export All Audit Data</span>
            </button>
          </mat-menu>
        </div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar" style="overflow: hidden; display: flex; height: 100%;">
        <mat-card-content class="mat-elevation-z2"
                          style="overflow: hidden; flex: auto; display: flex; flex-direction: column;">
          <div style="overflow: auto; height: 100%;">
            <table mat-table *ngIf="dataSource$ | async as dataSource" [dataSource]="dataSource" matSort class="table-width" style="width: 100%"
                   matSortActive="accessDateTime"
                   matSortDirection="desc"
                   (matSortChange)="sort($event)">
              <ng-container matColumnDef="documentName">
                <th mat-header-cell *matHeaderCellDef matTooltip="Document Name" style="width: 20%" mat-sort-header="doc.docTitle">Document Name</th>
                <td mat-cell *matCellDef="let element"><a (click)="openDocument(element.documentId)"
                                                          class="document-name-link" style="cursor: pointer; text-decoration: underline;">{{element.documentName}}</a></td>
              </ng-container>
              <ng-container matColumnDef="dateAccessed">
                <th mat-header-cell *matHeaderCellDef matTooltip="Date Accessed" style="width: 15%" mat-sort-header="accessDateTime">Date Accessed</th>
                <td mat-cell *matCellDef="let element">{{element.dateAccessed | date: 'medium'}}</td>
              </ng-container>
              <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef matTooltip="Username" style="width: 10%" mat-sort-header="user.userName">User</th>
                <td mat-cell *matCellDef="let element">{{element.username}}</td>
              </ng-container>
              <ng-container matColumnDef="case">
                <th mat-header-cell *matHeaderCellDef matTooltip="Case" mat-sort-header="case.caseName">Case</th>
                <td mat-cell *matCellDef="let element">{{element.case}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
              <tr mat-row *matRowDef="let row; columns:columnsToDisplay"></tr>
            </table>
          </div>
          <div class="paging-container">
            <mat-paginator [pageSize]="25" [pageSizeOptions]="[25, 50, 100, 200]"
                           [length]="totalEntries$ | async" (page)="movePage($event)" showFirstLastButtons #paginator></mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
